<form [id]="formId" [formGroup]="formGroup" (submit)="submit()">
  @let privacy = formGroup.get('privacy')!;
  @let marketing = formGroup.get('marketing')!;
  <div>
  <kendo-label [text]="'termsAndConditions.one' | translate"></kendo-label>
  <app-spacer/>
</div>
<div [innerHTML]="'termsAndConditions.two' | translate" style="overflow: hidden scroll;"></div>
<div>
  <app-spacer/>
  <div [innerHTML]="'termsAndConditions.three' | translate"></div>
  <div>
      <ul class="k-radio-list k-list-horizontal">
        <li class="k-radio-item">
          <kendo-radiobutton
            #privacyAccepted
            size="large"
            class="k-radio-label"
            value="true"
            [formControlName]="privacy | controlName">
          </kendo-radiobutton>
          <kendo-label
            [for]="privacyAccepted"
            class="k-radio-label"
            [text]="'termsAndConditions.accept' | translate">
          </kendo-label>
        </li>
        <li class="k-radio-item">
          <kendo-radiobutton
            #privacyNotAccepted
            size="large"
            class="k-radio-label"
            value="false"
            [formControlName]="privacy | controlName">
          </kendo-radiobutton>
          <kendo-label
            [for]="privacyNotAccepted"
            class="k-radio-label"
            [text]="'termsAndConditions.decline' | translate">
          </kendo-label>
        </li>
      </ul>
      @if (privacy.invalid && !privacy.untouched) {
        <kendo-formerror [textContent]="'termsAndConditions.error' | translate"/>
      }
      <kendo-label [text]="'termsAndConditions.privacy' | translate"/>
    </div>
  <app-spacer/>
  <div>
      <ul class="k-radio-list k-list-horizontal">
        <li class="k-radio-item">
          <kendo-radiobutton
            #marketingAccepted
            size="large"
            class="k-radio-label"
            value="true"
            [formControlName]="marketing | controlName">
          </kendo-radiobutton>
          <kendo-label
            [for]="marketingAccepted"
            class="k-radio-label"
            [text]="'termsAndConditions.accept' | translate">
          </kendo-label>
        </li>
        <li class="k-radio-item">
          <kendo-radiobutton
            #marketingNotAccepted
            size="large"
            class="k-radio-label"
            value="false"
            [formControlName]="marketing | controlName">
          </kendo-radiobutton>
          <kendo-label
            [for]="marketingNotAccepted"
            class="k-radio-label"
            [text]="'termsAndConditions.decline' | translate">
          </kendo-label>
        </li>
      </ul>
      @if (marketing.invalid && !marketing.untouched) {
        <kendo-formerror [textContent]="'termsAndConditions.errorMarketing' | translate"/>
      }
      <kendo-label [text]="'termsAndConditions.marketing' | translate"/>
    </div>
  <app-spacer/>
</div>
</form>
